//@ts-nocheck
import React from 'react';
import { AppTextField } from '../inputs';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../types';

export const BillingStateField: React.FC<FieldProps> = ({ margin }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      rules={{
        required: 'Region / State is required',
      }}
      name="address.state"
      render={({ field }) => (
        <AppTextField
          label="Region / State"
          margin={margin}
          fullWidth
          {...field}
          error={!!errors?.address?.state?.message}
          helperText={errors?.address?.state?.message || ''}
        />
      )}
    />
  );
};
